import { createFileRoute } from '@tanstack/react-router';
import { AdminReferencePage } from '../../features/catalogue';

export const Route = createFileRoute('/admin/catalogue/reference')({ component: AdminReferencePage });
